import { render } from "./IrDetailView.vue?vue&type=template&id=534cbb73&scoped=true"
import script from "./IrDetailView.vue?vue&type=script&lang=js"
export * from "./IrDetailView.vue?vue&type=script&lang=js"

import "./IrDetailView.vue?vue&type=style&index=0&id=534cbb73&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534cbb73"]])

export default __exports__